import { connect } from 'react-redux'

import {
  addRentalHistory,
  deleteTenantReference,
  editRentalHistory,
  fetchManagersForRentalHistory,
  fetchPropertyAttributes,
  fetchRentalHistory,
  fetchRentalReference,
  resetRentalReference,
} from 'app/bond_cover/bond_cover_actions'
import RentalHistoryAdd from 'app/profile/renter/rental_history/rental_history_form'
import { fetchApplication } from 'app/sm/apply/apply_actions'
import { fetchTeamSettingInformation } from 'app/sm/rental_reputation/actions'

const mapStateToProps = ({ Shared, bondCover, session, apply }) => ({
  historyPayload: bondCover.historyPayload,
  attributes: bondCover.attributes,
  rentalReference: bondCover.rentalReference,
  isEditMode: bondCover.rentalHistoryEditMode,
  currentUser: session.currentUser,
  rentalHistory: bondCover.rentalHistory,
  property: apply.property,
  backUrl: Shared.backUrl,
  isQLDForm22: apply.isQLDForm22,
})

const mapDispatchToProps = (dispatch) => ({
  fetchPropertyAttributes: () => dispatch(fetchPropertyAttributes()),
  fetchRentalHistory: () => dispatch(fetchRentalHistory()),
  addRentalHistory: (rentalHistory, success, fail, agencyGUID) =>
    dispatch(addRentalHistory(rentalHistory, success, fail, agencyGUID)),
  fetchRentalReference: (id) => dispatch(fetchRentalReference(id)),
  deleteTenantReference: (rentalHistoryGUID, rentalReferenceGUID) =>
    dispatch(deleteTenantReference(rentalHistoryGUID, rentalReferenceGUID)),
  editRentalHistory: (rentalHistory, id, success, fail, agencyGUID) =>
    dispatch(editRentalHistory(rentalHistory, id, success, fail, agencyGUID)),
  reset: () => dispatch(resetRentalReference()),
  fetchManagersForRentalHistory: (searchValue) =>
    dispatch(fetchManagersForRentalHistory(searchValue)),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
  fetchTeamSettingInformation: (teamId, queryString) =>
    dispatch(fetchTeamSettingInformation(teamId, queryString)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RentalHistoryAdd)
